var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "box-el-wrapper",
      class: { "greyscale unclickable": _vm.boxData.disabled },
      attrs: {
        "data-id": _vm.boxData.id,
        "data-name": _vm.boxData.name,
        "data-dd-action-name": _vm.boxData.name || _vm.boxData.title,
      },
    },
    [
      _c("div", { staticClass: "block", on: { click: _setup.handleOnClick } }, [
        _c("img", {
          staticClass: "box-img lazyload",
          class: { greyscale: _vm.boxData.available === false },
          attrs: {
            loading: "lazy",
            src: _vm.boxData.image,
            alt: `${_vm.boxData.name}`,
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-container" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c("div", { staticClass: "main-text" }, [
            _vm._v(_vm._s(_vm.boxData.title)),
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.bottom",
                  value: _vm.boxData.tooltip,
                  expression: "boxData.tooltip",
                  modifiers: { hover: true, bottom: true },
                },
              ],
              staticClass: "description",
            },
            [_vm._v(_vm._s(_vm.boxData.description))]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }